import api from './api/axiosConfig';

export interface HostOnboardingData {
  // Step 1: Pre-screening
  ownsOrManagesProperty: boolean;
  hasPlannedSpace: boolean;
  hasHighSpeedInternet: boolean;
  acceptsNetworkPolicies: boolean;
  
  // Step 2: Verification
  hostName: string;
  emailAddress: string;
  phoneNumber: string;
  businessName: string;
  businessType: string;
  address: string;
  latitude?: number;
  longitude?: number;
  neighborhoodDescription: string;
  
  // Step 3: Subscription
  selectedPlan: string;
  securitySubscription: string;
  quantity: number;
  
  // Step 4: Payment
  financingOption: string;
  installationOption: string;
}

export interface HostApplicationResponse {
  success: boolean;
  message: string;
  data: {
    hostPartner: any;
    user: {
      id: string;
      email: string;
      name: string;
    };
  };
}

export interface PasswordSetupResponse {
  success: boolean;
  message: string;
  data: {
    user: {
      id: string;
      email: string;
      name: string;
      role: string;
    };
    hostPartner: any;
    token: string;
  };
}

export const hostService = {
  // Submit host application
  async submitApplication(data: HostOnboardingData): Promise<HostApplicationResponse> {
    const response = await api.post('/host-partner/apply', data);
    return response.data;
  },

  // Setup password for new host
  async setupPassword(token: string, userId: string, password: string): Promise<PasswordSetupResponse> {
    const response = await api.post('/host-partner/setup-password', {
      token,
      userId,
      password,
    });
    return response.data;
  },

  // Get host profile (authenticated)
  async getProfile(): Promise<any> {
    const response = await api.get('/host-partner/profile');
    return response.data;
  },

  // Get host dashboard data (authenticated)
  async getDashboard(): Promise<any> {
    const response = await api.get('/host-partner/dashboard');
    return response.data;
  },

  // Get subscription for current user (authenticated)
  async getSubscription(): Promise<any> {
    const response = await api.get('/subscriptions');
    return response.data;
  },

  // Get subscription by user ID
  async getSubscriptionByUserId(userId: string): Promise<any> {
    const response = await api.get(`/subscriptions/user/${userId}`);
    return response.data;
  },
};
